/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-use-before-define */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
import { logger } from 'services';
import { MentionCommand } from './mentioncommand';

export class MentionEditing extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return 'MentionEditing';
  }

  /**
   * @inheritDoc
   */
  init() {
    const { editor } = this;
    const { model } = editor;
    const doc = model.document;

    // Allow the mention attribute on all text nodes.
    model.schema.extend('$text', { allowAttributes: 'mention' });

    // Upcast conversion.
    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        key: 'data-mention',
        classes: 'mention',
      },
      model: {
        key: 'mention',
        value: _toMentionAttribute,
      },
    });

    // Downcast conversion.
    editor.conversion.for('downcast').attributeToElement({
      model: 'mention',
      view: createViewMentionElement,
    });
    editor.conversion.for('downcast').add(preventPartialMentionDowncast);

    doc.registerPostFixer((writer) =>
      removePartialMentionPostFixer(writer, doc, model.schema),
    );
    doc.registerPostFixer((writer) =>
      extendAttributeOnMentionPostFixer(writer, doc),
    );
    doc.registerPostFixer((writer) =>
      selectionMentionAttributePostFixer(writer, doc),
    );

    editor.commands.add('mention', new MentionCommand(editor));
  }
}

export function _addMentionAttributes(baseMentionData, data) {
  return { uid: uid(), ...baseMentionData, ...(data || {}) };
}

export function _toMentionAttribute(viewElementOrMention, data) {
  const dataMention = viewElementOrMention.getAttribute('data-mention');

  const textNode = viewElementOrMention.getChild(0);

  // Do not convert empty mentions.
  if (!textNode) {
    return;
  }

  const baseMentionData = {
    id: dataMention,
    _text: textNode.data,
  };

  return _addMentionAttributes(baseMentionData, data);
}

function preventPartialMentionDowncast(dispatcher) {
  dispatcher.on(
    'attribute:mention',
    (evt, data, conversionApi) => {
      const mention = data.attributeNewValue;

      // ck has changed the responsibility of low level consumption of data. so we have to test ourself if we consumed this event before.
      // https://ckeditor.com/docs/ckeditor5/latest/updating/guides/update-to-33.html#responsibility-shift-in-the-lowlevel-downcast-converters
      if (!conversionApi.consumable.test(data.item, evt.name)) {
        return;
      }

      if (data.item == null) {
        logger.log(
          'Mention data item is null, logging for an app crash in project template task description',
        );
      }

      if (!data.item?.is('$textProxy') || !mention) {
        return;
      }

      const { start } = data.range;
      const textNode = start.textNode || start.nodeAfter;

      if (textNode.data !== mention._text) {
        // Consume item to prevent partial mention conversion.
        conversionApi.consumable.consume(data.item, evt.name);
      }
    },
    { priority: 'highest' },
  );
}

function createViewMentionElement(mention, { writer }) {
  if (!mention) {
    return;
  }

  const attributes = {
    class: 'mention',
    'data-mention': mention.id,
  };

  const options = {
    id: mention.uid,
    priority: 20,
  };

  return writer.createAttributeElement('span', attributes, options);
}

function selectionMentionAttributePostFixer(writer, doc) {
  const { selection } = doc;
  const { focus } = selection;

  if (
    selection.isCollapsed &&
    selection.hasAttribute('mention') &&
    shouldNotTypeWithMentionAt(focus)
  ) {
    writer.removeSelectionAttribute('mention');

    return true;
  }
}

function shouldNotTypeWithMentionAt(position) {
  const { isAtStart } = position;
  const isAfterAMention =
    position.nodeBefore && position.nodeBefore.is('$text');

  return isAfterAMention || isAtStart;
}

function removePartialMentionPostFixer(writer, doc, schema) {
  const changes = doc.differ.getChanges();

  let wasChanged = false;

  for (const change of changes) {
    // Checks the text node on the current position.
    const { position } = change;

    if (change.name === '$text') {
      const nodeAfterInsertedTextNode =
        position.textNode && position.textNode.nextSibling;

      // Checks the text node where the change occurred.
      wasChanged = checkAndFix(position.textNode, writer) || wasChanged;

      // Occurs on paste inside a text node with mention.
      wasChanged = checkAndFix(nodeAfterInsertedTextNode, writer) || wasChanged;
      wasChanged = checkAndFix(position.nodeBefore, writer) || wasChanged;
      wasChanged = checkAndFix(position.nodeAfter, writer) || wasChanged;
    }

    // Checks text nodes in inserted elements (might occur when splitting a paragraph or pasting content inside text with mention).
    if (change.name !== '$text' && change.type === 'insert') {
      const insertedNode = position.nodeAfter;

      for (const item of writer.createRangeIn(insertedNode).getItems()) {
        wasChanged = checkAndFix(item, writer) || wasChanged;
      }
    }

    // Inserted inline elements might break mention.
    if (change.type === 'insert' && schema.isInline(change.name)) {
      const nodeAfterInserted =
        position.nodeAfter && position.nodeAfter.nextSibling;

      wasChanged = checkAndFix(position.nodeBefore, writer) || wasChanged;
      wasChanged = checkAndFix(nodeAfterInserted, writer) || wasChanged;
    }
  }

  return wasChanged;
}

function extendAttributeOnMentionPostFixer(writer, doc) {
  const changes = doc.differ.getChanges();

  let wasChanged = false;

  for (const change of changes) {
    if (change.type === 'attribute' && change.attributeKey !== 'mention') {
      // Checks the node on the left side of the range...
      const { nodeBefore } = change.range.start;
      // ... and on the right side of the range.
      const { nodeAfter } = change.range.end;

      for (const node of [nodeBefore, nodeAfter]) {
        if (
          isBrokenMentionNode(node) &&
          node.getAttribute(change.attributeKey) !== change.attributeNewValue
        ) {
          writer.setAttribute(
            change.attributeKey,
            change.attributeNewValue,
            node,
          );

          wasChanged = true;
        }
      }
    }
  }

  return wasChanged;
}

function isBrokenMentionNode(node) {
  if (
    !node ||
    !(node.is('$text') || node.is('$textProxy')) ||
    !node.hasAttribute('mention')
  ) {
    return false;
  }

  const text = node.data;
  const mention = node.getAttribute('mention');

  const expectedText = mention._text;

  return text !== expectedText;
}

function checkAndFix(textNode, writer) {
  if (isBrokenMentionNode(textNode)) {
    writer.removeAttribute('mention', textNode);

    return true;
  }

  return false;
}
